const SET_BILLMASTER_LIST = '@billmaster/set-billmaster-list';
const SET_BILLMASTER_DETAIL = '@billmaster/set-billmaster-detail';
const SET_BILLMASTER_LIST_TOTAL = '@bill/set-bill-list-total';

export {SET_BILLMASTER_LIST, SET_BILLMASTER_DETAIL, SET_BILLMASTER_LIST_TOTAL};